import { createSlice } from '@reduxjs/toolkit';

const parametersSlice = createSlice({
    name: 'parameters',
    initialState: {
        LOADING_TYPE: "ball-beat",
        chatUrl: "http://127.0.0.1:3000",
        email: false,
        janusPrivate: "",
        janusPublic: "",
        janusSupportPrivate: "",
        janusSupportPublic: "",
        janusCodec: "pcmu",
        janusAgent: false,
        janusStatus: "",
        passwordHashed: false,
        passwordRecovery: false,
        changePassword: localStorage.getItem("faChangePwd") === "true",
        searchForms: "",
        janusDTMF: "",
        rtl: false,
        disableQueue: true,
        janusStarted: false,
        aiEnabled: false,
        passwordPolicy: false,
        showDashboard: true,
        showInbox: false,
        integrationScript: ""
    },
    reducers: {
        setChatUrl: (state, action) => {
            if (action.payload) {
                state.chatUrl = action.payload;
                if (!state.chatUrl.startsWith("http"))
                    state.chatUrl = `//${state.chatUrl}`;

                localStorage.setItem("faChatServer", action.payload);
            }

        },
        setEmail: (state, action) => {
            if (action.payload)
                state.email = action.payload;
        },
        setJanusParameters: (state, action) => {
            if (action.payload != null) {
                if (action.payload.janusURL && !action.payload.janusURL.startsWith("wss")) {
                    state.janusPrivate = `https://${action.payload.janusURL}/janus`;
                } else {
                    state.janusPrivate = `${action.payload.janusURL}/janus`;
                }

                state.janusPublic = action.payload.janusIP;

                if (action.payload.janusURL && !action.payload.janusBackupURL.startsWith("wss")) {
                    state.janusSupportPrivate = `https://${action.payload.janusBackupURL}/janus`;
                } else {
                    state.janusSupportPrivate = `${action.payload.janusBackupURL}/janus`;
                }
                state.janusSupportPublic = action.payload.janusBackupIP;
                state.janusCodec = action.payload.janusCodec;
            }
        },
        setJanusAgent: (state, action) => {
            if (action.payload != null)
                state.janusAgent = action.payload.Janus
        },
        changeJanusStatus: (state, action) => {
            console.log("JANUS status: " + action.payload);
            state.janusStatus = action.payload;
        },
        swapServers: (state, action) => {
            let janusPrivateFirst = state.janusPrivate;
            state.janusPrivate = state.janusSupportPrivate;
            state.janusSupportPrivate = janusPrivateFirst;
            let janusPublicFirst = state.janusPublic;
            state.janusPublic = state.janusSupportPublic;
            state.janusSupportPublic = janusPublicFirst;
        },
        setPasswordHashed: (state, action) => {
            if (action.payload != null)
                state.passwordHashed = action.payload;
        },
        setPasswordRecovery: (state, action) => {
            if (action.payload != null)
                state.passwordRecovery = action.payload;
        },
        setChangePassword: (state, action) => {
            if (action.payload != null)
                state.changePassword = action.payload;
        },
        setSearchForm: (state, action) => {
            if (action.payload) {
                state.searchForms = action.payload;
            }
        },
        setJanusDTMF: (state, action) => {
            state.janusDTMF = action.payload;
        },
        setRTL: (state, action) => {
            state.rtl = action.payload;
        },
        setDisableQueue: (state, action) => {
            state.disableQueue = action.payload;
        },
        setJanusStarted: (state, action) => {
            state.janusStarted = action.payload;
        },
        setAiEnabled: (state, action) => {
            state.aiEnabled = action.payload;
        },
        setPasswordPolicy: (state, action) => {
            if (action.payload != null)
                state.passwordPolicy = action.payload;
        },
        setShowDashboard: (state, action) => {
            state.showDashboard = action.payload;
        },
        setPhoneLength: (state, action) => {
            state.phoneLength = action.payload;
        },
        setShowInbox: (state, action) => {
            state.showInbox = action.payload;
        },
        setIntegrationScript: (state, action) => {
            state.integrationScript = action.payload;
        }
    }
});

export default parametersSlice.reducer
export const { setChatUrl, setEmail, setJanusParameters, setJanusAgent, changeJanusStatus, swapServers, setPasswordHashed, setPasswordRecovery,
    setChangePassword, setSearchForm, setJanusDTMF, setDisableQueue, setJanusStarted, setAiEnabled, setPasswordPolicy, setShowDashboard,
    setPhoneLength, setShowInbox, setIntegrationScript } = parametersSlice.actions